var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.scroller_back},[_c('div',{class:[_vm.$style.scroller, 'gnzs-1c-scroll-table-scroller'],style:({
    width: _vm.scrollWidth + 'px',
    'margin-left': _vm.scrollOffset + 'px'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }